import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Admin from '../views/Admin.vue'
import CardAdmin from '../views/CardAdmin.vue'
import UserAdmin from '../views/UserAdmin.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { isPublic: true }
  },
  {
    path: '/admin',
    component: Admin,
    children: [
      {
        path: '',
        name: 'Admin',
        component: CardAdmin
      },
      {
        path: 'user',
        name: 'UserAdmin',
        component: UserAdmin
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(page => page.meta.isPublic) || store.state.userName) {
    next()
  } else {
    next('/login')
  }
})


export default router
